module.exports = __webpack_public_path__ + "img/telegram2.ca6a4eca.svg";